import axios from "axios";

export const flashmix = {
  data() {
    return {
      currentNumber: '',
      userNumber: '',
      errors: 0,
      counter: 1,
      is_success: false,
      is_error: false,
      reset: 0,
      result: '',
      readyNext: false,
      preStart: false,
      finish: false,
      local_finish: false,
      results: [],
      local_results: [],
      scores: 0,
      local_steps: 1,
      stat_id: ''
    }
  },
  props: {
    qnt: '',
    params: '',
    inkey: ''
  },
  computed: {
    mode() {
      return this.params.mode;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    fullRestart() {
      this.finish = false;
      this.local_finish = false;
      this.counter = 0;
      this.errors = 0;
      // this.local_steps = 0
      this.scores = 0;
      this.results = [];
      this.restart();
      this.onStart();
    },
    onStart() {
      this.generateNumber();
      this.startTimer();
      this.preStart = true;
    },
    setStatus(val) {
      let app = this;
      this[val] = true;
      setTimeout(function () {
        app[val] = false;
      }, 1000)
    },
    checkError() {
      let num = String(this.userNumber);
      this.userNumber = Number(num.replace(/\D+/g,""));
      if (this.currentNumber == this.userNumber) {
        this.setStatus('is_success');
        this.result = this.currentNumber + " = " + this.userNumber;
      } else {
        this.setStatus('is_error');
        this.result = this.currentNumber + " <span class='fn'>≠</span> " + this.userNumber;
        if(!this.readyNext) this.errors++;
      }
    },
    speedy() {
      if (this.mode === 'fight') {
        let speed = +this.params.speed;
        let app = this;
        //console.log('Speedy -' + this.inkey, speed);
        setTimeout(function () {
          $('.showed_number-' + app.inkey).css('visibility', 'hidden');
        }, speed * 1000)
      }
    },
    addScores() {
      console.log('Add scores');
      let sum = 0;
      let result = this.results;
      let speed = this.params.mode === 'fight' ? this.params.speed : 1;
      result.forEach(function (e) {
        if (e.cifers == e.user_answer) {
          sum = sum + (e.cifers.toString().length / speed);
        } else {
          console.log('Ошибки не считаем');
        }
      });
      sum = Math.ceil(sum);

      if(this.$route.params.isHomework){
        sum = Math.ceil(sum * this.$store.state.hw_coefficient);
      }

      this.checkScoreStatus(sum);

      this.scores = sum;
      this.$store.commit('changeUserScores', sum);
      console.log('Баллов заработано', sum);
    },
    makeStats() {
      if (this.$parent.user.role.code === 'student') {
        let path = this.$route.params.is_matrius ? 'onSaveMatriusAnswer' : 'onSaveStats'
        console.log('Бережно сохраняем статистику');
        //let time = this.timer;
        let errors = this.errors;
        let train_params = this.params;
        let app = this;
        let stats = {
          //time: time,
          total: this.getTotalTime(this.local_results),
          errors: errors,
          count: this.local_steps,
          user_id: this.$store.state.user.id,
          trainer: this.$store.state.current_trainer.id,
          results: this.local_results,
          scores: this.scores,
          train_params: {
            direction: train_params.direction,
            qnt: train_params.qnt,
            speed: train_params.speed,
            from: train_params.from,
            to: train_params.to,
            mode: train_params.mode
          }
        }

        stats = this.checkHomework(stats);

        if (this.$route.params.is_matrius) {
          stats.student_task_id = this.$route.params.student_task_id
          stats.qnt = this.$route.params.qnt
        }

        let data = {
          'stat': stats
        }
        this.http.post(path, data).then((res) => {
          this.stat_id = res.data.id;
          this.checkCoins(res.data);

          if (this.$route.params.is_matrius && res.data.is_done) {
            swal('Успешно!', res.data.message, 'success')
            this.$router.push({ name: 'student_homework' });
          }
        })
        .catch(e => swal('Что-то пошло не так', '' + e, 'error'))

      } else {
        console.log('Учителей в статистику не заносим! Понятно?!');
      }
    },
    updateStats() {
      if (this.$parent.user.role.code === 'student') {
        console.log('Update stats');
        let results = this.local_results;
        let time = this.getTotalTime(results);
        let stat_id = this.stat_id;
        let arr = {
          result: results,
          time: time,
          errors: this.errors,
          stat_id: stat_id,
          count: this.local_steps,
          scores: this.scores,
          isHomework: this.$route.params.isHomework ? true : false
        }
        //console.log(arr);
        this.updateHomework();
        axios.post(window.location.href, { 'stat': arr }, {
          headers: {
            'X-OCTOBER-REQUEST-HANDLER': 'onUpdateStats',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then((res) => {
          this.checkCoins(res.data);
          //console.log(res);
        })

      }
    },
    getTotalTime(arr) {
      return _.reduce(arr, function (sum, i) {
        return sum + i.timer.total_ms;
      }, 0);
    }
  },
  mounted() {

  }
}